export default {
  default: () => import("/webapp/layouts/default.vue").then(m => m.default || m)
}